export const args = {
    data: [
        {
            id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
            title: 'No Usage , no Interest',
            subTitle: 'Pay interest only on the borrow amount',
            image: 'https://dev.files.bluelearn.in/STUDENT_PROFILE/AVATARS/MALE/2022-05-05T13%3A21%3A02%2B05%3A30-328.png',
        },
        {
            id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
            title: 'Instant Money Transfer',
            subTitle: 'Pay interest only on the borrow amount',
            image: 'https://dev.files.bluelearn.in/STUDENT_PROFILE/AVATARS/MALE/2022-05-05T13%3A21%3A02%2B05%3A30-328.png',
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            title: 'Limit Top-up , No Paper Work',
            subTitle: 'Pay interest only on the borrow amount',
            image: 'https://dev.files.bluelearn.in/STUDENT_PROFILE/AVATARS/MALE/2022-05-05T13%3A21%3A02%2B05%3A30-328.png',
        },
    ],
    heading: 'Why Volt?',
};
export const argTypes = {};
